export const getErrorMessage = (response, message, t) => {
    let details = response && response.data ? response.data : null
    return `${t(message)}${details && ` (${t(details)})`}`
}